<script>
  import { onMount, onDestroy } from 'svelte';
  import session from '../lib/session';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import Selector from '../lib/components/Selector.svelte';
  import Validators from '../lib/validators';

  // component options  ------------------------------------------------------ //

  export let id;
  export let phone;
  export let valid = true;
  export let error_message;

  // internal variables ------------------------------------------------------ //

  let items = [];
  let phone_code;
  let phone_country;
  let phone_number;
  const VALIDATION_DEBOUNCE_MS = 600;
  let phone_debounce_timer;

  // translated strings ------------------------------------------------------ //

  let phone_number_label = t9n(TS.PHONE_NUMBER_LABEL);
  let country_code_no_choice_text = t9n(TS.PHONE_AREA_CODE);

  // utility functions -------------------------------------------------------- //

  const load_country_codes = () => {
    items = $session.api_config.phone_country_codes
      .filter(item => item.country !== 'AX')
      .map(item => {
        return { val: item.code, name: `(${item.country}) ${item.code}` };
      });
  };

  const set_country = code => {
    const base = $session.api_config.phone_country_codes.filter(
      item => item.country !== 'AX'
    );
    const i11l_code = base.find(item => item.code === code);
    phone_country = !!i11l_code ? i11l_code.country : phone_country;
  };

  const set_phone = (country, code, number) => {
    phone = { country, code, number };
  };

  const validate_phone = async phone_obj => {
    let result = await Validators.validate_phone(phone_obj);
    valid = result.valid;
    error_message = result.error;
    console.log('error_message', error_message);
  };

  const init = () => {
    if ($session.api_config) {
      load_country_codes();
      set_country(phone_code);
      set_phone(phone_country, phone_code, phone_number);
    }
  };

  // reactive functions ------------------------------------------------------- //
  $: if (phone_code) set_country(phone_code);
  $: if (phone_number || phone_code) {
    set_phone(phone_country, phone_code, phone_number);
  }

  $: if (
    (!!phone_number && phone_number.length > 0) ||
    (!!phone_code && phone_code.length > 0)
  ) {
    clearTimeout(phone_debounce_timer);
    const current_phone = { country: phone_country, code: phone_code, number: phone_number };
    phone_debounce_timer = setTimeout(() => {
      validate_phone(current_phone);
    }, VALIDATION_DEBOUNCE_MS);
  }

  onDestroy(() => {
    clearTimeout(phone_debounce_timer);
  });

  onMount(init);
</script>

<svelte:options accessors={true} />

<div {id} class="phone-number-container">
  <div style="width: 138px; margin-right: 9px; ">
    <Selector
      id="phone_code_selector"
      invalid_text={error_message}
      label={country_code_no_choice_text}
      bind:items
      is_required={true}
      valid={valid}
      auto_complete={true}
      bind:value={phone_code} />
  </div>

  <InputWithValidation
    id='phone_number_input'
    type="tel"
    label={phone_number_label}
    name="forAutocompleteHackToWork"
    validate={false}
    is_required={true}
    bind:value={phone_number}
    valid={valid}
    validation_text={error_message}
    width='203px' />
</div>

<style>
  .phone-number-container {
    display: flex;
  }
</style>
